// extracted by mini-css-extract-plugin
export default {"TipMessage":"TipMessage_TipMessage__WYBC2","TipMessage__Red":"TipMessage_TipMessage__Red__tXCTv","TipMessage__Green":"TipMessage_TipMessage__Green__rVItc"};